export const HERO_IMAGE =
  'https://cdn.magicpatterns.com/patterns/generated-images/fe97062b-a737-4924-8f13-efb87e02a52e.jpg'

export const HERO_IMAGE_ALT =
  'Tennis 360 complete coaching kit: 12-volume box set with 6 bonus PDF guides'
